import { DtoBase } from "./DtoBase";
import { Guid } from "../DiscoveryEngine.TS/Utils/Guid";
import { UpdateResultDto } from "./UpdateResultDto";

export class StorageRootDto extends DtoBase {

	public Guid: string;
	public Created: string;
	public Modified: string;
	public ServerGuid: string;
	public TenantGuid: string;

	constructor() {
		super();
		this.Guid = "";
		this.Created = "";
		this.Modified = "";
		this.ServerGuid = "";
		this.TenantGuid = "";
	}

	public VerifyGuid(): string {
		if (!this.Guid) {
			this.Guid = Guid.Create().toString().toLowerCase();
		}
		return this.Guid;
	}

	public CopyProps(obj: UpdateResultDto, isCreate: boolean = true) {
		if (isCreate) {
			this.Guid = obj.Guid;
			this.Created = obj.Created;
		}

		this.Modified = obj.Modified;
	}

	public Equals(obj: any): boolean {
		if (!super.Equals(obj))
			return false;

		if (!(obj instanceof StorageRootDto))
			return false;
		let other: StorageRootDto = (obj as StorageRootDto);

		return (this.Guid === other.Guid &&
			this.Created === other.Created &&
			this.Modified === other.Modified &&
			this.ServerGuid === other.ServerGuid &&
			this.TenantGuid === other.TenantGuid);
	}

	public Write(obj: any, context: any): void {

		// Called by subclass Write methods

		super.Write(obj, context);

		if (this.Guid)
			obj.guid = this.Guid;

		if (this.Created)
			obj.created = this.Created;

		if (this.Modified)
			obj.modified = this.Modified;

		if (this.ServerGuid)
			obj.server_guid = this.ServerGuid;

		if (this.TenantGuid)
			obj.tenant_guid = this.TenantGuid;
	}

	public Read(obj: any, context: any): void {

		// Called by subclass Read methods

		super.Read(obj, context);

		if (obj.guid !== undefined)
			this.Guid = obj.guid;

		if (obj.created !== undefined)
			this.Created = obj.created;

		if (obj.modified !== undefined)
			this.Modified = obj.modified;

		if (obj.server_guid !== undefined)
			this.ServerGuid = obj.server_guid;

		if (obj.tenant_guid !== undefined)
			this.TenantGuid = obj.tenant_guid;
	}

}
